import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class StrategyData {
  public x: any;
  public y: any;
  public iY: any;
  public iX: any;

  public childIndex: any;
  public childRelationshipTypes: CubiqTS.OrderRelationshipType[] = [];
  public label: string;
  public id: string;
  public siblingRelationshipType: CubiqTS.OrderRelationshipType;
  public visitorPath: any = [];
}
